import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Check } from "lucide-react";
import { formatNGN } from "@/lib/api";
import { useCart } from "@/context/CartContext";

const TAG = /\[\[cart:([A-Z0-9-]+)\]\]/g;

export function parseCartTags(raw = "") {
  const skus = [...new Set([...raw.matchAll(TAG)].map((m) => m[1]))];
  let text = raw.replace(TAG, "");
  const open = text.lastIndexOf("[[");
  if (open >= 0 && !text.includes("]]", open)) text = text.slice(0, open);
  return { text: text.replaceAll("**", "").trim(), skus };
}

export const ChatProductCard = ({ product }) => {
  const { add } = useCart();
  const [added, setAdded] = useState(false);
  const onAdd = () => { add(product, 1); setAdded(true); };

  return (
    <div data-testid={`chat-product-${product.sku}`} className="flex items-center gap-3 p-3 rounded-xl bg-white" style={{ border: "1px solid var(--border)", maxWidth: "88%" }}>
      <img src={product.image_url} alt={product.name} className="w-14 h-14 rounded-lg object-cover flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate" style={{ color: "var(--ink)" }}>{product.name}</div>
        <div className="text-xs font-mono mt-0.5" style={{ color: "var(--ink-soft)" }}>{formatNGN(product.price_ngn)}</div>
        {added ? (
          <Link to="/cart" data-testid={`chat-view-cart-${product.sku}`} className="mt-2 inline-flex items-center gap-1 text-xs font-medium underline underline-offset-2" style={{ color: "var(--brand)" }}>
            <Check size={12} /> Added — view cart
          </Link>
        ) : (
          <button type="button" data-testid={`chat-add-${product.sku}`} onClick={onAdd} className="mt-2 inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3 py-1.5" style={{ background: "var(--ink)", color: "#fff" }}>
            <ShoppingCart size={12} /> Add to cart
          </button>
        )}
      </div>
    </div>
  );
};
